import { FC } from 'react';

import { Button } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { useRetailsContext } from '../RetailsContext';
import { ToggleMapButtonContainer } from './ToggleMapButton.styles';

export const ToggleMapButton: FC = () => {
    const { t } = useTranslations();

    const { selectedCity, selectedSalon, isMobileMapVisible, setIsMobileMapVisible } = useRetailsContext();

    if (!selectedCity || selectedCity.salons.length === 1 || !!selectedSalon) {
        return null;
    }

    const handleClick = () => {
        setIsMobileMapVisible(!isMobileMapVisible);
    };

    return (
        <ToggleMapButtonContainer>
            <Button variant="text" onClick={handleClick}>
                <span>
                    {
                        t[
                            isMobileMapVisible
                                ? 'retails_map.toggle_map.view_in_list'
                                : 'retails_map.toggle_map.view_in_map'
                        ]
                    }
                </span>
            </Button>
        </ToggleMapButtonContainer>
    );
};
